// This file handls timezone stuff with dayjs
// and sets the default timezone for the application.
// It also exports the dayjs instance for use in other files.
import dayjsLib from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjsLib.extend(utc);
dayjsLib.extend(timezone);
dayjsLib.extend(customParseFormat);

export const isValidTenantTimezone = (tz: string): boolean => {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz }).format();
    return true;
  } catch {
    return false;
  }
};

export const setDefaultTimezone = (tz: string) => {
  if (!isValidTenantTimezone(tz)) {
    throw new Error('Tenant timezone is missing or invalid.');
  }
  console.log('Setting default timezone to:', tz);
  dayjsLib.tz.setDefault(tz);
};

export const resetDefaultTimezone = () => {
  dayjsLib.tz.setDefault();
};

export const formatTenantDateKey = (
  value: string | number | Date,
  timezoneName: string
): string => {
  if (!isValidTenantTimezone(timezoneName)) {
    throw new Error('Tenant timezone is missing or invalid.');
  }
  const parsed = dayjsLib(value);
  if (!parsed.isValid()) throw new Error('Date value is invalid.');
  return parsed.tz(timezoneName).format('MMDDYYYY');
};

export const dayjs = dayjsLib;
export type { Dayjs } from 'dayjs';
